module.exports = __webpack_public_path__ + "static/media/Location.3f2428e4.svg";